import Popover from '@components/Popover/Popover';
import { useSentinelPhase } from '@hooks/useSentinelPhase';
import arrow from '@static/vectors/sentinel/arrow.svg';
import roleAvatar from '@static/vectors/sentinel/phase-banner';
import { FormattedMessage } from 'react-intl';
import type { Role } from 'src/types/sentinel';
import './PhaseBanner.css';

export default function PhaseBanner() {
	const { currentPhase, getPhaseClassName, activeSteps } = useSentinelPhase();

	if (!currentPhase) return null;
	const latestStep = activeSteps.length > 0 ? activeSteps[activeSteps.length - 1] : null;
	const backgroundSteps = activeSteps.length > 1 ? activeSteps.slice(0, -1).reverse() : [];
	const currentRole: Role = latestStep?.role || 'undefined';

	return (
		<aside id="sentinel-phase-banner" className={currentPhase && getPhaseClassName(currentPhase)}>
			<div className="banner-content">
				<h1 className="phase-title">
					<FormattedMessage id={`sentinel.sidebar-breadcrumb.${currentPhase}`} />
					<img className="role-avatar" src={roleAvatar?.[currentRole]} alt={`${currentRole} avatar`} />
				</h1>

				{latestStep && (
					<>
						<h2 className="banner-steps-role">
							<FormattedMessage id={`sentinel.phase-banner.role.${currentRole}`} />
						</h2>

						{backgroundSteps.length > 0 && (
							<Popover
								position="bottom"
								popoverClassName="banner-steps-popover"
								buttonClassName="banner-counter-btn"
								triggerContent={<strong className="counter-badge">+{backgroundSteps.length}</strong>}
							>
								<ul className="popover-steps-list">
									{backgroundSteps.map((step, index) => {
										const stepRole = step.role || 'undefined';
										return (
											<li key={step.id || `${step.stepId}-${index}`}>
												<img className="role-avatar" src={roleAvatar?.[stepRole]} alt={`${stepRole} avatar`} />
												<strong className="banner-steps-role">
													<FormattedMessage id={`sentinel.phase-banner.role.${stepRole}`} />:{' '}
												</strong>
												<span>
													<FormattedMessage id={`sentinel.timeline.step.${step.stepId}`} />
												</span>
											</li>
										);
									})}
								</ul>
							</Popover>
						)}
						<img className="arrow" src={arrow} alt="arrow" />
						<span className="current-step-text">
							<FormattedMessage id={`sentinel.timeline.step.${latestStep.stepId}`} />
						</span>
					</>
				)}
			</div>
		</aside>
	);
}
